import * as React from "react";
import { cn } from "../../lib/utils";

const Progress = React.forwardRef(({ className, value = 0, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "relative h-2 w-full overflow-hidden rounded-full bg-gray-700",
      className
    )}
    {...props}
  >
    <div 
      className="h-full w-full flex-1 bg-purple-600 transition-all"
      style={{ transform: `translateX(-${100 - value}%)` }}
    />
  </div>
));

Progress.displayName = "Progress";

export { Progress };
